import { render, staticRenderFns } from "./ModalEdicaoDestaque.vue?vue&type=template&id=e3798ac0&scoped=true"
import script from "./ModalEdicaoDestaque.vue?vue&type=script&lang=js"
export * from "./ModalEdicaoDestaque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3798ac0",
  null
  
)

export default component.exports